namespace Nobox.Nobox {
    export interface CampaignTemplateRow {
        Id?: number;
        Name?: string;
        ChannelId?: number;
        InteractiveMsg?: string;
        ChannelNm?: string;
        Subject?: string;
        BodyType?: Nobox.BodyType.BodyTypeEnum;
        Body?: string;
        BodyHtml?: string;
        BodyText?: string;
        In?: string;
        Up?: string;
        Template?: number;
        TenantId?: number;
        Attachment?: string;
    }

    export namespace CampaignTemplateRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Nobox.CampaignTemplate';
        export const lookupKey = 'Nobox.CampaignTemplate';

        export function getLookup(): Q.Lookup<CampaignTemplateRow> {
            return Q.getLookup<CampaignTemplateRow>('Nobox.CampaignTemplate');
        }
        export const deletePermission = 'Campaign:Delete';
        export const insertPermission = 'Campaign:Modify';
        export const readPermission = 'Campaign:View';
        export const updatePermission = 'Campaign:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            ChannelId = "ChannelId",
            InteractiveMsg = "InteractiveMsg",
            ChannelNm = "ChannelNm",
            Subject = "Subject",
            BodyType = "BodyType",
            Body = "Body",
            BodyHtml = "BodyHtml",
            BodyText = "BodyText",
            In = "In",
            Up = "Up",
            Template = "Template",
            TenantId = "TenantId",
            Attachment = "Attachment"
        }
    }
}
